import React from "react";
import ProductItem from "../../components/product/ProductItem";
// BtnAddToCart
import MiniBtnAddToCart from "../../components/layout/Buttons/MiniBtn-Add-To-Cart";

const hiddenProductAttributeKeys = new Set([
  "Spider_Source",
  "Spider_Source_Product_Code",
  "Spider_Source_Product_Id",
  "Spider_Source_Url",
  "Spider_Source_Image_Url",
  "Spider_Source_Category_Name",
  "Spider_Source_Category_Path",
  "TODO_Remark",
]);

/**
 * 获取当前商品列表中需要展示的动态属性键。
 * @param {Array<Record<string, any>>} products 商品列表
 * @returns {string[]} 动态属性键列表
 */
const getVisibleAttributeKeys = (products = []) => {
  const attributeKeys = [];

  products.forEach((product) => {
    Object.keys(product?.product_Attributes || {}).forEach((key) => {
      if (!hiddenProductAttributeKeys.has(key) && !attributeKeys.includes(key)) {
        attributeKeys.push(key);
      }
    });
  });

  return attributeKeys;
};

/**
 * 渲染商品列表表格，固定基础列并追加商品动态属性列。
 * @param {{ products?: Array<Record<string, any>> }} props 组件属性
 * @returns {React.JSX.Element} 商品列表表格
 */
const ProductsTable = ({ products}) => {
  const attributeKeys = getVisibleAttributeKeys(products);
  const dynamicMinWidth = 800 + attributeKeys.length * 140;

  return (
    <div className="overflow-x-auto w-full">
      <table
        className="border-t-0 border-black border-solid md:border-t-4 border-[#011936] w-full"
        style={{ minWidth: `${dynamicMinWidth}px` }}
      >
        <thead className="md:table-header-group">
          <tr className="bg-white md:bg-[#E7E9EB] *:p-1 md:*:p-3 *:bg-inherit *:text-[#2684fe] md:*:text-[#2684fe] *:font-bold *:text-[10px] md:*:text-sm uppercase tracking-wider">
            <th className="sticky md:static left-0 z-20 bg-white md:bg-inherit w-[100px] md:w-[350px] border-r-2 border-solid border-r-gray-400/20 text-center shadow-[2px_0_5px_-2px_rgba(0,0,0,0.1)] md:shadow-none">
              Product Details
            </th>
            <th className="border-r-2 border-solid border-r-gray-400/20 text-center">Datasheet</th>
            <th className="border-r-2 border-solid border-r-gray-400/20 text-center">Manufacturer</th>
            <th className="border-r-2 border-solid border-r-gray-400/20 text-center">Stock</th>
            <th className="border-r-2 border-solid border-r-gray-400/20 text-center">Price ($)</th>
            <th className="border-r-2 border-solid border-r-gray-400/20 text-center">Creatyea Part No.</th>
            {attributeKeys.map((key) => (
              <th
                key={key}
                className="border-r-2 border-solid border-r-gray-400/20 text-center min-w-[140px] max-w-[220px]"
                title={key}
              >
                <span className="block truncate">{key}</span>
              </th>
            ))}
            <th className="sticky md:static right-0 z-20 bg-white md:bg-inherit text-center shadow-[-2px_0_5px_-2px_rgba(0,0,0,0.1)] md:shadow-none">
              Order
            </th>
          </tr>
        </thead>
        <tbody>
          {products?.map((product, i) => (
            <tr
              key={product?._id}
              className="bg-white *:py-4 *:px-3 *:border-b border-gray-200 transition-colors duration-200 hover:bg-gray-50"
            >
              <ProductItem product={product} attributeKeys={attributeKeys} />
              <td className="sticky md:static right-0 z-10 bg-white md:bg-inherit border-l-0 border-solid md:border-l-2 border-l-gray-400/20 shadow-[-2px_0_5px_-2px_rgba(0,0,0,0.1)] md:shadow-none">
                <div className="flex items-center justify-center w-full bg-inherit">
                  <MiniBtnAddToCart {...product} />
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ProductsTable;
